import { CustomCellRendererProps } from 'ag-grid-react'

import { useTradeCounterpartiesQuery } from '@/react-query/queries/static'

export interface CounterpartyIdCellRendererProps extends CustomCellRendererProps {}

export const CounterpartyIdCellRenderer: React.FC<CounterpartyIdCellRendererProps> = ({
  value,
}) => {
  const query = useTradeCounterpartiesQuery()

  const label = query.data?.find((c) => c.value == value)?.label ?? value

  return <>{label}</>
}
